import { Input } from "~/components/ui/input";
import { Textarea } from "~/components/ui/textarea";

type QuestionTextFieldProps = {
  ariaDescribedBy?: string;
  ariaLabelledBy?: string;
  multiline?: boolean;
  onChange: (value: string) => void;
  placeholder?: string;
  value: string;
};

export function QuestionTextField({
  ariaDescribedBy,
  ariaLabelledBy,
  multiline = false,
  onChange,
  placeholder = "Upiši odgovor ovde",
  value,
}: QuestionTextFieldProps) {
  if (multiline) {
    return (
      <Textarea
        value={value}
        onChange={(event) => onChange(event.target.value)}
        placeholder={placeholder}
        aria-labelledby={ariaLabelledBy}
        aria-describedby={ariaDescribedBy}
        className="min-h-40 resize-y rounded-md border-border bg-background p-4 text-base leading-7 shadow-none focus-visible:ring-brand"
      />
    );
  }

  return (
    <Input
      value={value}
      onChange={(event) => onChange(event.target.value)}
      placeholder={placeholder}
      aria-labelledby={ariaLabelledBy}
      aria-describedby={ariaDescribedBy}
      className="h-14 rounded-md border-border bg-background px-4 text-base shadow-none focus-visible:ring-brand"
    />
  );
}
